import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LoginMiddleware from "./middleware/LoginMiddleware.js";

import Home from "./pages/home";
import PremiumPlans from "./pages/PremiumPlans/PremiumPlans.jsx";
import Contact from "./pages/Contact/Contact.jsx";

import Register from "./pages/forms/Register";
import Login from "./pages/login/login.jsx";
import ForgotPassword from "./pages/login/forgotpassword.jsx";

import Dashboard from "./dashboard/dashboard.jsx";
import EditProfilePage from "./sidebarprofile/editprofilepage.jsx";
import AllProfilePage from "./sidebarprofile/allprofilepage.jsx";
import SearchProfilePage from "./sidebarprofile/searchprofilepage.jsx";
import View from "./viewprofile.jsx";
import RecentProfilePage from "./sidebarprofile/recentprofilepage.jsx";
import IntretsedProfilePage from "./sidebarprofile/IntrestedProfilePage.jsx";
import ViewedProfilePage from "./sidebarprofile/viewedProfile.jsx";
import ViewedMyProfilePage from "./sidebarprofile/viewedMyProfile.jsx";
import ShortListProfilePage from "./sidebarprofile/ShortListedProfilePage.jsx";
import PurchasedProfilePage from "./sidebarprofile/purchasedProfilePage.jsx";
import PdfPage from "./components/pdf/pdf.js";
import AdminDownloadpdf from "./components/Admin-pdf/AdminPdfDownload.jsx";
import AboutUs from "./pages/Aboutus/Aboutus.jsx"
import { enableAppProtection } from "./middleware/AppProtection.js";
import SuccessStories from "./pages/SuccessStories/SuccessStories.jsx";
import PendingPayment from "./pages/pending-payment/pendingPayment.jsx";
import AppPdfPage from "./components/App-pdf/AppPdf.jsx";
import NotFound from "./pages/NotFound/NotFound.jsx";

const App = () => {
  useEffect(() => {
    enableAppProtection();
  }, []);
  return (
    <Router>
      <Routes>
        <Route element={<LoginMiddleware />}>
          <Route path="/search" element={<SearchProfilePage />} />
          <Route path="/pending-payment" element={<PendingPayment />} />
          <Route path="/edit-profiles" element={<EditProfilePage />} />

          <Route path="/all-profiles" element={<AllProfilePage />} />
          <Route path="/recent-profiles" element={<RecentProfilePage />} />
          <Route
            path="/interested-profiles"
            element={<IntretsedProfilePage />}
          />
          <Route path="/viewed-profiles" element={<ViewedProfilePage />} />
          <Route path="/viewed-my-profiles" element={<ViewedMyProfilePage />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route
            path="/purchased-profiles"
            element={<PurchasedProfilePage />}
          />
          <Route path="/view/:id" element={<View />} />
          <Route
            path="/shortlisted-profiles"
            element={<ShortListProfilePage />}
          />
        </Route>

        <Route path="/" element={<Home />} />
        <Route path="/premiumplans" element={<PremiumPlans />} />
        <Route path="/contact" element={<Contact />} />

        <Route path="/login" element={<Login />} />
        <Route path="/forgotpassword" element={<ForgotPassword />} />
        <Route path="/bio-data/:id" element={<PdfPage />} />
        <Route path="/app-bio-data/:id" element={<AppPdfPage />} />
        <Route path="/admin-bio-data/:id" element={<AdminDownloadpdf />} />
        <Route path="/register" element={<Register />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/success-stories" element={<SuccessStories />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
};

export default App;
